/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'lock-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M8 1a2 2 0 012 2v4H6V3a2 2 0 012-2m3 6V3a3 3 0 00-6 0v4a2 2 0 00-2 2v5a2 2 0 002 2h6a2 2 0 002-2V9a2 2 0 00-2-2"/>',
    },
});
